import axios from 'axios';
import semver from 'semver';
import packjson from '../../package.json';
import {
  getCategory,
  getSeason,
  getBrand,
  getVendor,
  getCategory2,
  getSeason2,
  getBrand2,
  getVendor2,
} from '@/api/promotion';
import * as _ from 'lodash';

let util = {

};

util.inOf = function (arr, targetArr) {
  let res = true;
  arr.forEach(item => {
    if (targetArr.indexOf(item) < 0) {
      res = false;
    }
  });
  return res;
};

util.oneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true;
  } else {
    return false;
  }
};

util.showThisRoute = function (itAccess, currentAccess) {
  if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
    return util.oneOf(currentAccess, itAccess);
  } else {
    return itAccess === currentAccess;
  }
};

util.getRouterObjByName = function (routers, name) {
  if (!name || !routers || !routers.length) {
    return null;
  }
  let routerObj = null;
  for (let item of routers) {
    if (item.name === name) {
      return item;
    }
    routerObj = util.getRouterObjByName(item.children, name);
    if (routerObj) {
      return routerObj;
    }
  }
  return null;
};

util.handleTitle = function (vm, item) {
  if (typeof item.title === 'object') {
    return vm.$t(item.title.i18n);
  } else {
    return item.title;
  }
};

util.mapRouters = function (vm) {
  let routerParentMap = {};
  vm.$store.state.app.routers.forEach(item => {
    loopRouters(item, routerParentMap);
  });
  vm.$store.commit('setRouterNameParentMap', routerParentMap);
}

function loopRouters(router, map) {
  if (router.children == undefined || router.children.length == 0) {
    return;
  }
  router.children.forEach(item => {
    map[item.name] = router;
    loopRouters(item, map);
  });
}

function getCurrentPathArr(vm, routerNameParentMap, currentPathArr, currentRouter) {
  let parent = routerNameParentMap[currentRouter.name];
  if (parent && parent.children.length > 1) {
    if (routerNameParentMap[currentRouter.name]) {
      currentPathArr.push({
        title: parent.title,
        name: parent.name
      });
      getCurrentPathArr(vm, routerNameParentMap, currentPathArr, parent)
    }
  }
}

util.setCurrentPath = function (vm, to) {
  let currentRouter = util.getRouterObjByName(vm.$store.state.app.routers, to.name)

  let currentPathArr = [];
  if(currentRouter.parent){
    currentPathArr = currentRouter.parent.concat(currentRouter);
  } else {
    currentPathArr = [{
        title: currentRouter.title,
        path: to.path,
        name: currentRouter.name
    }];
    let routerNameParentMap = vm.$store.state.app.routerNameParentMap;
    getCurrentPathArr(vm, routerNameParentMap, currentPathArr, currentRouter);

    currentPathArr.reverse();
  }


  vm.$store.commit('setCurrentPath', currentPathArr);
  return currentPathArr;
};

util.validateResponse = function (vm, response) {
  if (response.data.status === 1) {
    return true;
  }
  vm.$Message.error(response.data.message);
  return false;
}

util.handleErrorMsg = function (vm, error) {
  if (error.response) {
    vm.$Message.error(error.response.data.message);
  } else {
    vm.$Message.error(error.message);
  }
}

util.toDefaultPage = function (routers, name, route, next) {
  let len = routers.length;
  let i = 0;
  let notHandle = true;
  while (i < len) {
    if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
      route.replace({
        name: routers[i].children[0].name
      });
      notHandle = false;
      next();
      break;
    }
    i++;
  }
  if (notHandle) {
    next();
  }
};

util.initCommonData = function (vm, flag) {
  initCategory(vm, flag);
  initSeason(vm, flag);
  initBrand(vm, flag);
  initVendor(vm, flag);
};


function initSeason(vm, flag) {
  let req = null;
  if (flag) {
    req = getSeason2();
  } else {
    req = getSeason();
  }
  req.then(response => {
    if (util.validateResponse(vm, response)) {
      // if (response.data.status == 1) {
      let seasons = response.data.data;
      vm.$store.commit('setSeasonList', seasons);
    }

  });
}

function initBrand(vm, flag) {
  let req = null;
  if (flag) {
    req = getBrand2();
  } else {
    req = getBrand();
  }
  req.then(response => {
    let brandNameIdMap = {
      'ALL': -1
    };
    if (util.validateResponse(vm, response)) {
      // if (response.data.status == 1) {
      let brandNameList = [];
      let brands = response.data.data
      for (let i = 0; i < brands.length; i++) {
        if (flag) {
          brands[i].key = brands[i].brand_id.toString();
          const english_name = _.trim(brands[i].english_name);
          brandNameList.push(english_name);
          brandNameIdMap[english_name] = brands[i].brand_id;
        } else {
          brands[i].key = brands[i].brandId.toString();
          const englishName = _.trim(brands[i].englishName);
          brandNameList.push(englishName);
          brandNameIdMap[englishName] = brands[i].brandId;
        }
      }
      vm.$store.commit('setBrandNameIdMap', brandNameIdMap);
      const tempList = _.uniq(brandNameList).sort();
      tempList.unshift('ALL');
      vm.$store.commit('setBrandList', tempList);
    }
  }).catch;

}

function initCategory(vm, flag) {
  let req = null;
  if (flag) {
    req = getCategory2();
  } else {
    req = getCategory();
  }
  req.then(response => {
    if (util.validateResponse(vm, response)) {
      // if (response.data.status == 1) {
      let categorys = [{
        categoryId: -1,
        children: [],
        level: 0,
        name: "All Category",
        parentId: -1
      }];
      categorys[0].children = response.data.data;
      let categoryIdMap = {};
      categoryIdMap['-1'] = categorys;
      for (let i = 0; i < categorys.length; i++) {
        mappingCategory(categorys[i], categoryIdMap)
      }
      vm.$store.commit('setCategoryTree', categorys);
      vm.$store.commit('setCategoryIdMap', categoryIdMap);
    }
  });
}

function initVendor(vm, flag) {
  let req = null;
  if (flag) {
    req = getVendor2();
  } else {
    req = getVendor();
  }
  req.then(response => {
    if (util.validateResponse(vm, response)) {
      // if (response.data.status == 1) {
      let boutiqueList = response.data.data;
      let vendorNameIdMap = {};
      let vendorList = [];
      boutiqueList.forEach(item => {
        for (let key in item) {
          if (key == 'vendor_id') {
            item['vendorId'] = item[key];
          }
          if (key == 'vendor_name') {
            item['vendorName'] = item[key];
          }
          delete item[key];
        }
        const venderName = _.trim(item.vendorName);
        vendorList.push(venderName);
        vendorNameIdMap[venderName] = item.vendorId;
      });
      vm.$store.commit('setBoutiqueList', boutiqueList);
      vm.$store.commit('setVendorList', vendorList.sort());
      vm.$store.commit('setVendorNameIdMap', vendorNameIdMap);
    }
  });
}

function mappingCategory(category, categoryIdMap) {
  for (let key in category) {
    if (key == 'children' || key == 'parentId' || key == 'level') {
      continue;
    }
    if (key == 'categoryId') {
      category['value'] = category[key];
      //delete category[key];
      continue;
    }
    if (key == 'name') {
      category['title'] = category[key];
      category['label'] = category[key];
      //delete category[key];
      continue;
    }
    delete category[key];
  }
  categoryIdMap[category.categoryId] = category;
  if (category.children) {
    for (let i = 0; i < category.children.length; i++) {
      mappingCategory(category.children[i], categoryIdMap)
    }
  }
}

util.removeCookie = function (keyName) {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) {
      if (_.trim(keys[i]) === keyName) {
        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
        break;
      }
    }
  }
};

var SIGN_REGEXP = /([yMdhsm])(\1*)/g
var DEFAULT_PATTERN = 'yyyy-MM-dd'

function padding(s, len) {
  let l = len - (s + '').length
  for (var i = 0; i < l; i++) {
    s = '0' + s
  }
  return s
}

util.dateFormat = function (date, pattern) {
  pattern = pattern || DEFAULT_PATTERN
  return pattern.replace(SIGN_REGEXP, function ($0) {
    switch ($0.charAt(0)) {
      case 'y':
        return padding(date.getFullYear(), $0.length)
      case 'M':
        return padding(date.getMonth() + 1, $0.length)
      case 'd':
        return padding(date.getDate(), $0.length)
      case 'w':
        return date.getDay() + 1
      case 'h':
        return padding(date.getHours(), $0.length)
      case 'm':
        return padding(date.getMinutes(), $0.length)
      case 's':
        return padding(date.getSeconds(), $0.length)
    }
  })
};

util.map2QueryString = function (params) {
  let queryString = "?";

    for (let key in params) {
      queryString += key + "=" + params[key] + "&"
    }
    if(queryString.length > 1){
      queryString = queryString.substring(0,queryString.length -1);
    }
    else{
      queryString = "";
    }
    return queryString;
}


util.dateParse = function (dateString, pattern) {
  var matchs1 = pattern.match(SIGN_REGEXP)
  var matchs2 = dateString.match(/(\d)+/g)
  if (matchs1.length === matchs2.length) {
    var _date = new Date(1970, 0, 1)
    for (var i = 0; i < matchs1.length; i++) {
      var _int = parseInt(matchs2[i])
      var sign = matchs1[i]
      switch (sign.charAt(0)) {
        case 'y':
          _date.setFullYear(_int);
          break
        case 'M':
          _date.setMonth(_int - 1);
          break
        case 'd':
          _date.setDate(_int);
          break
        case 'h':
          _date.setHours(_int);
          break
        case 'm':
          _date.setMinutes(_int);
          break
        case 's':
          _date.setSeconds(_int);
          break
      }
    }
    return _date
  }
  return null
};

util.triggerEvent=function(el,eventName){
       var event;
       if(document.createEvent){
           event = document.createEvent('MouseEvent');
           event.initEvent(eventName,true,true);
       }else if(document.createEventObject){// IE < 9
           event = document.createEventObject();
           event.eventType = eventName;
       }
       if(el.dispatchEvent){
           el.dispatchEvent(event);
       }else if(el.fireEvent && htmlEvents['on'+eventName]){// IE < 9
           el.fireEvent('on'+event.eventType,event);// can trigger only real event (e.g. 'click')
       }else if(el[eventName]){
           el[eventName]();
       }else if(el['on'+eventName]){
           el['on'+eventName]();
       }
}

util.formatDateTime=function(time, format) {
        var t = new Date(time);
        var tf = function(i) {
          return (i < 10 ? "0" : "") + i;
        };
        return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a) {
          switch (a) {
            case "yyyy":
              return tf(t.getFullYear());
              break;
            case "MM":
              return tf(t.getMonth() + 1);
              break;
            case "mm":
              return tf(t.getMinutes());
              break;
            case "dd":
              return tf(t.getDate());
              break;
            case "HH":
              return tf(t.getHours());
              break;
            case "ss":
              return tf(t.getSeconds());
              break;
          }
        });
      }
      
export default util;
